<template>
  <div>
    <div class="cricket-partnership-list" v-if="innings.partnerships.length > 0">
      <div class="partnership" v-for="ps in innings.partnerships" :key="ps.index">
        <div class="players">
          <div class="one clickable" @click="onPlayerSelected(ps.player1.key)">{{match.players[ps.player1.key].name}}</div>
          <div class="runs" :class="{'info': ps.runs >= 10, 'alert': ps.runs < 10}"><span>{{ps.runs}}({{ps.balls}})</span><span v-if="!ps.dismissed">*</span> {{ps.four}}x4s {{ps.six}}x6s</div>
          <div class="two clickable" @click="onPlayerSelected(ps.player2.key)">{{match.players[ps.player2.key].name}}</div>
        </div>
        <div class="score">
          <div class="one">{{ps.player1.runs}}({{ps.player1.balls}}) {{ps.player1.fours}}x4s {{ps.player1.sixes}}x6s</div>
          <div class="bar" :class="{'notout': !ps.dismissed, 'live': match.status.isLive}">
            <div class="item" :style="{width:ps.player1.balWidth+'%'}"></div>
            <div class="item player1" :style="{width:ps.player1.width+'%'}"></div>
            <div class="item player2" :style="{width:ps.player2.width+'%'}"></div>
            <div class="item" :style="{width:ps.player2.balWidth+'%'}"></div>
          </div>
          <div class="two">{{ps.player2.runs}}({{ps.player2.balls}}) {{ps.player2.fours}}x4s {{ps.player2.sixes}}x6s</div>
        </div>
      </div>
    </div>
    <div v-else>Partnerships is not available</div>
  </div>
</template>
<script>
export default {
  props: {
    match: Object,
    inningsNumber: String,
    teamI: String
  },
  computed: {
    innings () {
      return this.match.innings[`${this.teamI}_${this.inningsNumber}`]
    }
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
